import React, { useState } from "react";
import { IonContent, IonButton, IonIcon } from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import "./TrackTreatments.css";
import "../Onboarding.css";
import CustomCheckbox from "../../inputs/checkbox/CheckBox";
import analytics from "../../../services/firebaseAnalytics";

interface TrackTreatmentsProps {
  prevStep: () => void;
  nextStep: (index?: number) => void;
  proceed: (selectedTreatments: string[]) => void;
  currentStep: number;
  steps: any[];
}

const TrackTreatments: React.FC<TrackTreatmentsProps> = ({
  prevStep,
  nextStep,
  proceed,
  currentStep,
  steps,
}) => {
  // State for tracking selected treatments
  const [selectedTreatments, setSelectedTreatments] = useState<string[]>([]);

  // Treatment options
  const treatmentOptions = [
    { id: "breathing_treatment", label: "Breathing routines" },
    { id: "vest_treatment", label: "Vest treatments" },
  ];

  // Handle checkbox changes
  const handleCheckboxChange = (id: string) => {
    setSelectedTreatments((prev) => {
      let updated: string[];
      if (prev.includes(id)) {
        updated = prev.filter((item) => item !== id);
      } else {
        updated = [...prev, id];
      }
      // Async IIFE to handle preferences
      (async () => {
        try {
          const prefsPayload = {
            other_treatments: updated.reduce(
              (acc, item) => ({ ...acc, [item]: true }),
              {}
            ),
          };
        } catch (error) {
          console.error("Error updating/creating preferences:", error);
        }
      })();

      return updated;
    });
  };

  // Handle next button click
  const handleNext = async () => {
    proceed(selectedTreatments);
  };

  // Log analytics event when component is mounted
  React.useEffect(() => {
    const logAnalyticsEvent = async () => {
      await analytics.logEvent("onboarding_track_treatments_viewed", {
        selectedTreatments: selectedTreatments.join(","),
      });
    };
    logAnalyticsEvent();
    // Only run on mount or when selectedTreatments changes
  }, [selectedTreatments]);

  return (
    <IonContent className="ion-padding track-treatments-content">
      {/* Back Navigation */}
      <div className="navigation-header">
        <button className="back-text-button" onClick={prevStep}>
          <IonIcon icon={chevronBack} className="back-icon" />
          <span>Back</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="treatments-container">
        <h1 className="treatments-title">Track Treatments</h1>

        <p className="treatments-subtitle">
          Would you like to track other breathing therapy or treatments?
        </p>

        {/* Checkboxes */}
        <div className="checkboxes-container">
          {treatmentOptions.map((option) => (
            <div className="checkbox-row" key={option.id}>
              <label className="custom-checkbox">
                <CustomCheckbox
                  checked={selectedTreatments.includes(option.id)}
                  onChange={() => handleCheckboxChange(option.id)}
                  label={option.label}
                />
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Progress Indicator (optional) */}
      {steps && (
        <div className="progress-indicator">
          {steps.map((_, index) => (
            <div
              key={index}
              className={`progress-dot ${
                currentStep === index ? "active" : ""
              }`}
            />
          ))}
        </div>
      )}

      {/* Next Button */}

      <div
        className="button-stack-container w-full flex flex-col  gap-3"
        // style={{ bottom: 33 }}
      >
        <IonButton
          expand="block"
          className="primary-button"
          onClick={handleNext}
        >
          Next
        </IonButton>
        <button className="skip-link" onClick={() => nextStep()}>
          {/* Skip for now */}
        </button>
      </div>
    </IonContent>
  );
};

export default TrackTreatments;
